import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import '../public/static/free.css';


import ElementUI from 'element-ui';
import "theme-vue";
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';
import permission from './plugins/permission'
Vue.use(permission)
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import vueScroll from "vuescroll";//引入vuescroll
import "vuescroll/dist/vuescroll.css";//引入vuescroll样式
Vue.use(vueScroll);//使用

import router from './router.js';
import store from './store'

Vue.config.productionTip = false
import { getListByDictType } from "@/api/sys/dictData";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree,closeAndToPage,download } from "@/utils/common";
// Vue.prototype.imageUrlprefix = getListByDictType
Vue.prototype.getDicts = getListByDictType
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.closeAndToPage = closeAndToPage
Vue.prototype.download = download


/**
 * 测试环境---图片基础路径
 */
// Vue.prototype.$baseUrl = 'https://common.qyhzs.vip/file/';

/**
 * 生产环境---图片基础路径
 */
Vue.prototype.$baseUrl = 'https://jyzx.qyhzs.vip/file/'; 

/**
 * 晓辉局域网---图片基础路径
 */
// Vue.prototype.$baseUrl = 'http://192.168.10.241:8803';

import Pagination from "@/components/Pagination";


Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}


// 全局组件挂载
Vue.component('Pagination', Pagination)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
